import { browser } from '../../../common/services/browser';

const downloadFile = (src) => {
  const style = `width: 0; height: 0; border: 0; outline: 0; visibility: hidden;`;
  const frameId = `download-iframe-${new Date().getTime()}`;
  angular
    .element(document.body)
    .append(`<iframe id="${frameId}" src="${src}" style="${style}"></iframe>`);
  setTimeout(() => {
    angular.element(document.getElementById(frameId)).remove();
  }, 60000);
};

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank');
  if (newWindow) {
    newWindow.addEventListener('load', () => {
      newWindow.close();
    });
  }
};

export const download = (url) => {
  if (browser.isIos()) {
    openInNewTab(url);
  } else {
    downloadFile(url);
  }
};

export default angular
  .module('doxy.realtime.common.directives.dDownload', [])
  .directive('dDownload', function () {
    return {
      scope: {
        url: '=dDownload',
      },
      link: function (scope, elem) {
        elem.bind('click', function () {
          download(scope.url);
        });
      },
    };
  }).name;
